export default __webpack_public_path__ + "static/media/info.4aaa5662.svg";